export const consetPolicyKeys = {
  componentNameKey: 'CookieConsent_Dataset_Component_DisqusComments',
  componentNameDefault: 'Disqus Comments',
  companyNameKey: 'CookieConsent_Dataset_Component_DisqusComments',
  companyNameDefault: 'Disqus Comments',
};
